import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import shouldOpenInCompose from './shouldOpenInCompose';

export default function canRead(item: CalendarEvent): boolean {
    if (shouldOpenInCompose(item)) {
        return false;
    }
    return !!(item.EffectiveRights && item.EffectiveRights.Read);
}
